import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthorizeGuardAllowService } from 'src/app/services/authorize-guard-allow.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-cambiar-contrasena',
  templateUrl: './cambiar-contrasena.component.html',
  styleUrls: ['./cambiar-contrasena.component.css']
})
export class CambiarContrasenaComponent {

  passwordError = new FormControl('', [Validators.required]);
  errorMessage: string = "";
  errorVisible: boolean = false;
  hide = true;
  hideR = true;
  errorContrasenhaIguales: boolean = false;
  errroContrasenhaPequenha: boolean = false;
  errorNingunaContrasenha: boolean = false;

  signin: FormGroup;

  constructor(public userService : UserService, public router: Router, private formBuilder: FormBuilder, private authorizeGuard: AuthorizeGuardAllowService){

    this.signin = this.formBuilder.group({
      password: new FormControl('', [Validators.required, Validators.minLength(8)],),
      passwordR: new FormControl('', [Validators.required, Validators.minLength(8)])
    });

  }

  get passwordInput() { 
    return this.signin.get('password'); 
  }
  get passwordRInput() { 
    return this.signin.get('passwordR'); 
  } 

  continuar() {
    this.errorVisible = false;
    //Error contraseña iguales
    if (this.passwordInput?.value === this.passwordRInput?.value) {
      this.errorContrasenhaIguales = false;
    } else {
      this.errorContrasenhaIguales = true;
    }
    //Error contraseña pequeña
    if(this.passwordInput?.hasError('minlength')){
      this.errroContrasenhaPequenha = true;
    }else{
      this.errroContrasenhaPequenha = false;
    }
    //Error contraseña vacía
    if (this.passwordInput?.value == "") {
      this.errorNingunaContrasenha = true;
    } else {
      this.errorNingunaContrasenha = false;
    }
    //Comprobar que la contraseña sea una contraseña correcta
      //Cambiar contraseña
    //Devolver respuesta error o success
    console.log(this.passwordInput?.value);
    console.log(this.passwordRInput?.value);
  }

  getErrorMessagePassword() {
    if (this.passwordInput?.hasError('required')) {
      return 'Debes ingresar una contraseña';
    }
    return '';
  }

  getErrorMessagePasswordR() {
    if (this.passwordRInput?.hasError('required')) {
      return 'Debes ingresar una contraseña';
    }
    return '';
  }
}
